<template>
  <b-container fluid>
    <form @submit.stop.prevent="uploadData">
      <b-form-group
        label="Upload File:"
        label-for="file-data"
        label-cols-lg="2"
      >
        <b-form-file
          id="file-data"
          accept=".pdf"
          v-model="newFileData"
        ></b-form-file>
      </b-form-group>
      <div v-if="name === undefined">
        <b-form-group
          label="File Name:"
          description="This CANNOT be changed later."
        >
          <div>
            <b-form-input
              autocomplete="off"
              v-model="newFileName"
              v-on:keyup="onKeyDown"
            ></b-form-input>
          </div>
        </b-form-group>
      </div>
      <div v-show="submitting === false">
        <div v-show="readyToSend">
          <b-button
            block
            :disabled="!readyToSend"
            variant="primary"
            v-on:click="uploadData"
            >{{ computedButtonLabel }}</b-button
          >
        </div>
        <div v-show="!readyToSend">
          <p>Complete the form above to submit your changes.</p>
        </div>
      </div>
    </form>
    <b-container v-if="submitting">
      <b-spinner></b-spinner>
    </b-container>
  </b-container>
</template>

<script>
import axios from "axios";
export default {
  name: "Uploader",
  props: {
    buttonLabel: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: false,
    },
  },
  methods: {
    clearFile: function() {
      this.newFileData = null;
    },
    dataSuccessfullySubmitted: function() {
      this.submitting = false;
      this.newFileData = undefined;
      this.newFileName = undefined;
      this.formName = "";
      this.$emit("didSubmit");
    },
    uploadData: function() {
      console.log("upload data triggered HoOORay");
      if (this.readyToSend === false) {
        return;
      }
      this.$route.query.uid;
      var bodyFormData = new FormData();
      bodyFormData.append("name", this.fileName);
      bodyFormData.append("data", this.newFileData);
      var endpointURL = "/backend/" + this.$route.query.uid + "/assign";
      axios({
        method: "post",
        url: endpointURL,
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(() => {
          this.dataSuccessfullySubmitted();
        })
        .catch(() => {
          this.dataSuccessfullySubmitted();
        });
    },
    onKeyDown: function(eventInput) {
      eventInput.preventDefault();
      console.log(eventInput);
      console.log(eventInput.keyCode);
      this.filterInput(this.newFileName);
    },
    filterInput: function(something) {
      this.newFileName = something.replace(/\W/g, "");
    },
  },
  computed: {
    fileName: function() {
      if (this.name !== undefined) {
        return this.name;
      } else {
        return this.newFileName;
      }
    },
    readyToSend: function() {
      if (
        this.newFileData &&
        ((this.newFileName !== undefined && this.newFileName.length > 0) ||
          (this.name !== undefined && this.name.length > 0))
      ) {
        return true;
      }
      return false;
    },
    computedButtonLabel: function() {
      if (this.submitting === true) {
        return "Submitting";
      }
      return this.buttonLabel;
    },
  },
  components: {},
  data() {
    return {
      newFileData: undefined,
      newFileName: undefined,
      submitting: false,
    };
  },
};
</script>

<style></style>
